<script>
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import {contacts, requisites} from "@js/company_details.ts";
import {formatPhone} from "@js/helpers.ts";
import {Link} from "@inertiajs/vue3";

export default {
    name: "PublicOfferPage",
    components: {Link, MobileTopBar, Breadcrumbs},
    setup() {
        return {contacts, requisites, formatPhone};
    }
}
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs class="mb-2"/>
        <h1 class="text-2xl md:text-3xl">Публичная оферта</h1>
        <hr class="mt-5 mb-5"/>

        <div class="mb-10">
            <h2 class="text-xl font-medium mb-5">Основные понятия</h2>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Сайт</span> — сайт Вторчермет-1, размещенный в сети Интернет по адресу
                https://vtorchermet-1.ru.
            </p>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Компания</span> — ООО «Вторчермет-1», ИНН {{ requisites.inn }},
                КПП {{ requisites.kpp }}, ОГРН {{ requisites.ogrn }}.
            </p>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Юридический адрес</span> — {{ requisites.ur_address }}.
            </p>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Пользователь</span> — любое физическое лицо, индивидуальный
                предприниматель или юридическое лицо, использующее сайт в информационных целях, для связи с компанией
                или для направления заявки.
            </p>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Сдатчик</span> — физическое лицо, ИП или юридическое лицо, которое
                передает или планирует передать лом и отходы черных и/или цветных металлов на условиях, согласованных
                с компанией.
            </p>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Заявка</span> — обращение пользователя, оформленное через формы сайта,
                по телефону, электронной почте, мессенджеру или иным доступным способом, содержащее намерение сдать
                металлолом, заказать вывоз, демонтаж, оценку либо консультацию.
            </p>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Лом и отходы металлов</span> — лом и отходы черных и/или цветных
                металлов, допустимые к приему в соответствии с законодательством РФ, внутренними правилами компании и
                техническими требованиями безопасности.
            </p>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Услуги</span> — информационное сопровождение, консультации,
                предварительная оценка, выезд специалиста, вывоз металлолома, демонтаж металлоконструкций, погрузка,
                сортировка, взвешивание и иные сопутствующие работы, если они согласованы сторонами.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">1. Общие положения</h2>

            <p class="text-sm mb-2">
                1.1. Настоящий документ является публичной офертой и регулирует порядок использования сайта,
                направления заявок, а также общие условия взаимодействия между Пользователем и ООО «Вторчермет-1».
            </p>

            <p class="text-sm mb-2">
                1.2. Используя сайт, отправляя заявку, заказывая звонок, направляя фото металлолома, документы или
                иные материалы, Пользователь подтверждает согласие с условиями настоящей Оферты.
            </p>

            <p class="text-sm mb-2">
                1.3. Сведения, размещенные на сайте, включая ориентировочные цены, описания услуг, условия вывоза,
                демонтажа и приема лома, носят информационный характер и не являются окончательными условиями сделки,
                если прямо не указано иное.
            </p>

            <p class="text-sm mb-2">
                1.4. Окончательные условия конкретной сделки, включая стоимость, категорию металлолома, засоренность,
                необходимость демонтажа, логистику, форму расчета, сроки и перечень работ, определяются по результатам
                согласования между сторонами.
            </p>

            <p class="text-sm mb-2">
                1.5. Компания вправе в любое время изменять содержание сайта и настоящую Оферту без предварительного
                уведомления. Новая редакция вступает в силу с момента публикации на сайте.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">2. Предмет оферты</h2>

            <p class="text-sm mb-2">
                2.1. Компания предоставляет Пользователю возможность:
            </p>

            <ul class="text-sm list-disc pl-5 mb-3 space-y-2">
                <li>получить информацию о приеме металлолома и сопутствующих услугах;</li>
                <li>направить заявку на сдачу металлолома;</li>
                <li>заказать вывоз металлолома с адреса пользователя;</li>
                <li>запросить предварительную оценку по описанию, фото или видео;</li>
                <li>согласовать демонтаж металлоконструкций и сопутствующие работы;</li>
                <li>получить консультацию по порядку приема, взвешивания, сортировки и расчета.</li>
            </ul>

            <p class="text-sm mb-2">
                2.2. Размещение заявки на сайте не означает автоматического заключения сделки. Сделка считается
                согласованной после подтверждения условий компанией и, при необходимости, оформления документов,
                предусмотренных законодательством и внутренними процедурами.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">3. Порядок оформления и обработки заявки</h2>

            <p class="text-sm mb-2">
                3.1. Пользователь может оформить заявку через сайт, по телефону
                {{ formatPhone(contacts.sales_department_phone) }} или по электронной почте {{ contacts.info_mail }}.
            </p>

            <p class="text-sm mb-2">
                3.2. При оформлении заявки Пользователь обязан предоставить достоверную информацию, достаточную для
                связи и предварительной обработки обращения.
            </p>

            <p class="text-sm mb-2">
                3.3. Для предварительной оценки Пользователь может направить фотографии, видео, описание металлолома,
                ориентировочный объем, адрес объекта и иные сведения. Такая оценка является предварительной и может
                быть изменена после осмотра, сортировки, взвешивания и определения фактических характеристик лома.
            </p>

            <p class="text-sm mb-2">
                3.4. Компания вправе уточнить у Пользователя дополнительные сведения, необходимые для согласования
                выезда, безопасности работ, возможности погрузки, доступа транспорта, демонтажа и расчета.
            </p>

            <p class="text-sm mb-2">
                3.5. Компания вправе отказать в исполнении заявки в случае отсутствия технической возможности,
                недостоверности предоставленных сведений, нарушения требований безопасности, сомнений в законности
                происхождения металлолома либо по иным законным основаниям.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">4. Условия приема металлолома</h2>

            <p class="text-sm mb-2">
                4.1. Прием металлолома осуществляется в соответствии с законодательством Российской Федерации,
                внутренними правилами компании, а также требованиями по безопасности, радиационному контролю и
                взрывобезопасности.
            </p>

            <p class="text-sm mb-2">
                4.2. Пользователь обязуется передавать только тот лом и отходы металлов, которым он вправе
                распоряжаться на законных основаниях.
            </p>

            <p class="text-sm mb-2">
                4.3. Компания вправе запросить документы, подтверждающие личность, полномочия, принадлежность имущества,
                право распоряжения металлоломом, а также иные документы, необходимые по закону или по характеру сделки.
            </p>

            <p class="text-sm mb-2">
                4.4. Не принимаются предметы, оборот которых ограничен или запрещен, а также материалы, представляющие
                опасность для жизни, здоровья, окружающей среды, транспорта, персонала или оборудования.
            </p>

            <p class="text-sm mb-2">
                4.5. Компания вправе отказать в приеме металлолома при выявлении признаков радиоактивного загрязнения,
                взрывоопасности, наличия горюче-смазочных материалов, подозрительных конструкций, закрытых емкостей,
                боеприпасов, кабеля и оборудования с повышенным риском либо иных опасных факторов до их надлежащей
                проверки и допуска.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">5. Цена, взвешивание и расчет</h2>

            <p class="text-sm mb-2">
                5.1. Цены, опубликованные на сайте, если они размещаются, являются ориентировочными и могут меняться в
                зависимости от рыночной ситуации, объема, категории металлолома, степени засоренности, необходимости
                сортировки, демонтажа, погрузки, удаленности объекта и иных факторов.
            </p>

            <p class="text-sm mb-2">
                5.2. Итоговая стоимость определяется по фактическим характеристикам металлолома после осмотра,
                сортировки, взвешивания, определения засоренности и категории материала.
            </p>

            <p class="text-sm mb-2">
                5.3. Если предусмотрен выезд транспорта или специалистов, стоимость таких услуг, а также возможность
                их включения в общий расчет, согласуются отдельно.
            </p>

            <p class="text-sm mb-2">
                5.4. Если характер сделки предполагает удержание стоимости дополнительных работ, транспортных расходов,
                погрузки, демонтажа, резки, сортировки, аренды техники или иных расходов, такие удержания подлежат
                согласованию с Пользователем заранее.
            </p>

            <p class="text-sm mb-2">
                5.5. Расчет с Сдатчиком производится в порядке, форме и сроки, согласованные сторонами и допустимые
                действующим законодательством РФ.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">6. Вывоз, погрузка и демонтаж</h2>

            <p class="text-sm mb-2">
                6.1. Компания может оказывать услуги по вывозу металлолома, погрузке, демонтажу металлоконструкций,
                резке и иным сопутствующим работам при наличии технической возможности.
            </p>

            <p class="text-sm mb-2">
                6.2. Пользователь обязан обеспечить безопасный и законный доступ к объекту, месту хранения металлолома,
                подъездным путям, территории, а также при необходимости — наличие пропусков, разрешений и согласований.
            </p>

            <p class="text-sm mb-2">
                6.3. Если на объекте имеются ограничения, скрытые риски, опасные зоны, действующее оборудование,
                конструкции под напряжением, горючие материалы, резервуары, коммуникации или иные опасные условия,
                Пользователь обязан сообщить об этом заранее.
            </p>

            <p class="text-sm mb-2">
                6.4. Компания вправе приостановить или отказаться от выполнения работ, если условия на объекте создают
                угрозу жизни, здоровью, имуществу или нарушают требования законодательства.
            </p>

            <p class="text-sm mb-2">
                6.5. Подробнее об условиях выезда и логистики можно ознакомиться на странице
                <Link :href="route('deliveryAndShipping')"
                      class="underline hover:text-navHoverColor leading-tight transition font-bold">
                    доставки и вывоза
                </Link>.
            </p>

            <p class="text-sm mb-2">
                6.6. Информацию о порядке сдачи металлолома можно также посмотреть на странице
                <Link :href="route('howToHandOver')"
                      class="underline hover:text-navHoverColor leading-tight transition font-bold">
                    как сдать металлолом
                </Link>.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">7. Права и обязанности сторон</h2>

            <p class="text-sm mb-2">
                7.1. Пользователь обязуется предоставлять достоверную информацию, не вводить компанию в заблуждение
                относительно вида, происхождения и состояния металлолома, а также соблюдать закон и требования
                безопасности.
            </p>

            <p class="text-sm mb-2">
                7.2. Компания обязуется добросовестно рассматривать заявки, предоставлять информацию по условиям приема
                и, при наличии возможности, организовывать выполнение согласованных работ.
            </p>

            <p class="text-sm mb-2">
                7.3. Компания вправе привлекать к исполнению отдельных обязательств третьих лиц: перевозчиков,
                подрядчиков, специалистов по демонтажу, логистов и иных исполнителей.
            </p>

            <p class="text-sm mb-2">
                7.4. Компания вправе отказать в обслуживании лицам, нарушающим требования законодательства, правила
                безопасности, нормы делового общения или предоставляющим заведомо ложную информацию.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">8. Ответственность</h2>

            <p class="text-sm mb-2">
                8.1. Компания не несет ответственности за невозможность оказания услуг или исполнения заявки по
                причинам, не зависящим от нее, включая действия третьих лиц, ограничения доступа на объект,
                недостоверность данных пользователя, небезопасные условия, обстоятельства непреодолимой силы и иные
                объективные препятствия.
            </p>

            <p class="text-sm mb-2">
                8.2. Компания не отвечает за убытки, возникшие вследствие предоставления пользователем неверных данных,
                сокрытия существенных обстоятельств, отсутствия полномочий на распоряжение металлоломом либо нарушения
                требований законодательства.
            </p>

            <p class="text-sm mb-2">
                8.3. Сайт может временно быть недоступен по техническим причинам, и компания не гарантирует его
                бесперебойную работу в каждый момент времени.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">9. Персональные данные</h2>

            <p class="text-sm mb-2">
                9.1. Персональные данные обрабатываются в соответствии с законодательством РФ и Политикой
                конфиденциальности, размещенной на сайте.
            </p>

            <p class="text-sm mb-2">
                9.2. Направляя заявку, Пользователь соглашается на обработку персональных данных в объеме,
                необходимом для рассмотрения обращения, связи, согласования условий сделки, организации выезда,
                демонтажа, вывоза, расчета и исполнения обязательств.
            </p>

            <p class="text-sm mb-2">
                9.3. Компания вправе направлять сервисные сообщения, связанные с заявкой, по указанным Пользователем
                контактным данным.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">10. Урегулирование споров</h2>

            <p class="text-sm mb-2">
                10.1. Все споры и разногласия стороны стремятся урегулировать путем переговоров и обмена документами.
            </p>

            <p class="text-sm mb-2">
                10.2. Претензии могут быть направлены на адрес электронной почты {{ contacts.info_mail }} либо иным
                способом, позволяющим подтвердить факт отправки и получения обращения.
            </p>

            <p class="text-sm mb-2">
                10.3. При недостижении соглашения спор подлежит разрешению в порядке, предусмотренном действующим
                законодательством Российской Федерации.
            </p>
        </div>

        <div>
            <h2 class="text-xl mb-5 font-medium">11. Контактные данные</h2>

            <p class="text-sm mb-2">
                Телефон: {{ formatPhone(contacts.sales_department_phone) }}
            </p>

            <p class="text-sm mb-2">
                E-mail: {{ contacts.info_mail }}
            </p>

            <p class="text-sm mb-2">
                ООО «Вторчермет-1», ИНН {{ requisites.inn }}, КПП {{ requisites.kpp }}, ОГРН {{ requisites.ogrn }}
            </p>

            <p class="text-sm mb-2">
                Юридический адрес: {{ requisites.ur_address }}
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.prose a {
    @apply text-yellow-600 hover:text-yellow-800 underline;
}
</style>
